/* eslint-disable camelcase */
import { EditorExtensionSDK } from '@contentful/app-sdk';

export type EntryType =
  | 'soundpiece'
  | 'video'
  | 'meme'
  | 'category'
  | 'station'
  | 'article'
  | 'creator'
  | 'channel'
  | 'podcast'
  | 'show'
  | 'format'
  | 'profile'
  | 'soundpiece';

export type EntryTypeGroup =
  | 'App Types'
  | 'Videos'
  | 'Memes'
  | 'Soundpieces'
  | 'Formate'
  | 'Show'
  | 'Kategorien'
  | 'Stations'
  | 'Artikel'
  | 'Creators'
  | 'Channels'
  | 'Podcasts'
  | 'Soundpieces'
  | 'Channels & Podcasts'
  | 'Shows, Formate & Profile';

export const TAGGING_TOOL_MEDIA_TYPES: EntryTypeGroup[] = [
  'Memes',
  'Videos',
  'Channels',
  'Soundpieces',
];

export interface ManualEntry {
  id: string;
  entryId: string;
  type: EntryType;
  position?: number;
}

export interface ManualEntryCard extends ManualEntry {
  title: string;
  description?: string;
  thumbnailUrl?: string;
  typeDisplayName: string;
  publishState?: ContentfulEntryPublishState;
  imageUrl?: string;
  editUrl?: string;
}

export type DisplayStyleProps = 'Grid' | 'Carousel';

export interface TaggingToolEntryCard {
  id: string;
  type: 'video' | 'meme' | 'soundpiece';
  name: string;
  description: string;
  thumbnailUrl: string;
  entryId: string;
  position?: number;
}

export interface Tag {
  taggingToolId: number;
  title: string;
  contentfulEntityId: string;
  contentfulTypeId: string;
}

export interface TaggingToolTag {
  id: number;
  title: string;
  // eslint-disable-next-line camelcase
  contentful_entity_id: string;
  // eslint-disable-next-line camelcase
  contentful_type_id: string;
  // eslint-disable-next-line camelcase
  deleted_at: string | null;
}

export interface TargetPageCard {
  id: string;
  type?: string;
  title?: string;
  publishState: ContentfulEntryPublishState;
}

export type ContentfulEntryPublishState =
  | 'deleted'
  | 'archived'
  | 'changed'
  | 'draft'
  | 'published'
  | undefined;

export interface EditorProps {
  sdk: EditorExtensionSDK;
}

export interface ContentTypeInValidation {
  in: string[];
  linkContentType: string[];
}

export interface Pagination {
  per_page: number;
  total: number;
  current_page: number;
}

export interface PaginatedData<T> {
  status: 'success' | 'error';
  data: T;
  pagination: Pagination | null;
}

export interface CtfAppInstanceParameters {
  appApiUrl: string;
  taggingToolUrl: string;
  taggingToolApiToken: string;
}

export interface TaggingToolEntryBase {
  id: string;
  title?: string;
  description?: string;
  imageUrl?: string;
}

export interface TaggingToolEntry {
  id: string;
  title: string;
  description: string;
  type: EntryType;
  editUrl: string;
  imageUrl?: string;
}

export interface ApiChannelEntry {
  id: string;
  name: string;
  short_name: string;
  logo_url: string;
  stream_url: string;
  stream_url_low: string;
  background_desktop_url: null;
  background_mobile_url: null;
  description_long: string | null;
  description_short: string | null;
  tags: string;
}
